export const UserRole = Object.freeze({ 
    CANDIDATE: 'candidate',
    HR: 'hr'
}); 